module.exports = __webpack_public_path__ + "img/icon_camera.51e2bc4f.png";